import React from "react";
import { motion } from "framer-motion";
import { Instagram, Facebook, Mail, MessageCircle } from "lucide-react";
import { NAV_LINKS, CONFIG, fadeUp } from "../../data";
import { scrollToId } from "./Navbar";

export const Closing = () => (
  <section className="relative py-24 md:py-36 overflow-hidden" style={{ background: "var(--navy)" }}>
    <div className="absolute inset-0 opacity-70" style={{ background: "radial-gradient(700px circle at 50% 100%, rgba(25,118,210,0.16), transparent 55%)" }} />
    <div className="container-x relative z-10 text-center">
      <motion.h2 variants={fadeUp} initial="hidden" whileInView="show" viewport={{ once: true }}
        className="font-display font-bold tracking-tighter text-4xl md:text-6xl lg:text-7xl leading-[1.03] text-ivory">
        Every conversation matters.<br />
        <span style={{ color: "var(--gold)" }}>Every action counts.</span>
      </motion.h2>
      <motion.p variants={fadeUp} custom={1} initial="hidden" whileInView="show" viewport={{ once: true }}
        className="font-body text-ivory/75 text-base md:text-lg leading-relaxed max-w-2xl mx-auto mt-8">
        Progress is built together, one step at a time. Every visit, every message and every small effort is a chance to
        understand each other a little better — and to keep building something we can all be proud of.
      </motion.p>
      <motion.p variants={fadeUp} custom={2} initial="hidden" whileInView="show" viewport={{ once: true }}
        className="font-display font-bold tracking-[0.3em] text-lg md:text-xl mt-10" style={{ color: "var(--gold)" }}>
        LISTEN. LEARN. SERVE.
      </motion.p>
    </div>
  </section>
);

export const Footer = () => (
  <footer className="relative pt-20 pb-8 overflow-hidden" style={{ background: "#040a14" }}>
    <div className="container-x relative z-10">
      <div className="grid md:grid-cols-12 gap-10 pb-14 border-b border-white/10">
        <div className="md:col-span-5">
          <span className="font-display font-bold text-2xl text-ivory">PUTT<span style={{ color: "var(--gold)" }}>RAJ</span></span>
          <p className="font-body text-ivory/85 text-sm leading-relaxed mt-4 max-w-sm">
            The digital office of a public leader who believes good things start with a good conversation.
          </p>
          <div className="flex gap-3 mt-6">
            <a href={CONFIG.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="h-10 w-10 rounded-full border border-white/15 flex items-center justify-center text-ivory hover:bg-white/5 transition-colors"><Instagram size={17} /></a>
            <a href={CONFIG.facebook} target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="h-10 w-10 rounded-full border border-white/15 flex items-center justify-center text-ivory hover:bg-white/5 transition-colors"><Facebook size={17} /></a>
            <a href={`mailto:${CONFIG.email}`} aria-label="Email" className="h-10 w-10 rounded-full border border-white/15 flex items-center justify-center text-ivory hover:bg-white/5 transition-colors"><Mail size={17} /></a>
            <a href={`https://wa.me/${CONFIG.whatsapp}`} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp" className="h-10 w-10 rounded-full border border-white/15 flex items-center justify-center text-ivory hover:bg-white/5 transition-colors"><MessageCircle size={17} /></a>
          </div>
        </div>
        <div className="md:col-span-4">
          <p className="eyebrow mb-4" style={{ color: "var(--gold)" }}>Explore</p>
          <ul className="grid grid-cols-2 gap-2">
            {NAV_LINKS.map((l) => (
              <li key={l.href}>
                <button onClick={() => scrollToId(l.href)} className="font-body text-sm text-ivory/85 hover:text-[var(--gold)] transition-colors">{l.label}</button>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-3">
          <p className="eyebrow mb-4" style={{ color: "var(--gold)" }}>Office</p>
          <p className="font-body text-sm text-ivory/85 leading-relaxed">
            Shezan Lavelle, 4th Floor, No. 15, Walton Road, Shanthala Nagar, Ashok Nagar, Bengaluru – 560001
          </p>
          <a href={`mailto:${CONFIG.email}`} className="font-body text-sm text-ivory/85 hover:text-white transition-colors mt-3 inline-block">{CONFIG.email}</a>
        </div>
      </div>

      <div className="flex flex-col md:flex-row items-center justify-between gap-3 pt-7">
        <p className="font-body text-xs text-ivory/75">© 2026 Puttraj. All Rights Reserved.</p>
        <div className="flex items-center gap-4">
          <span className="inline-flex items-center gap-1.5 font-body text-xs text-ivory/85" data-testid="footer-affiliation">
            <img src="/photos/congress.png" alt="Indian National Congress" className="h-4 w-4 rounded-full object-contain" />
            Indian National Congress
          </span>
          <p className="font-body text-xs text-ivory/70 hidden md:block">Built for genuine, human communication.</p>
        </div>
      </div>
    </div>
    <div className="font-display font-bold text-white/[0.03] text-center leading-none select-none mt-6"
      style={{ fontSize: "clamp(3rem, 15vw, 12rem)" }}>PUTTRAJ</div>
  </footer>
);
